module.exports = __webpack_public_path__ + "img/thumbnail_CommonWombat_m_normal.7bd51bf3.png";